export default [
    '/app/mfa',
    '/app/approval-status',
    '/app/logout',
    '/app/serviceStopped',
    '/app/unavailable',
    '/app/mfaDisclosure',
    '/app/disclosure',
    '/app/secondaryDisclosure',
    '/app/disclosures',
    '/app/setupMFA',
    '/app/emailPrompt',
    '/app/emailUpdateComplete',
    '/app/mShowMySettings',
    '/app/register',
    '/app/bb/register',
    '/app/updatePin',
    '/app/authUpdate',
    '/app/authenticatorPrompt',
    '/app/authenticatorPromptComplete',
    '/app/login/consumer',
    '/app/postLogin',
];
